import { garconClient } from "@apis/axiosClients"
import { DateTime } from "luxon"

export const getEligibleRewardsForAccount = async (accountId, callback) => {
  const today = DateTime.local().startOf("day").toISO()
  try {
    const response = await garconClient.get(
      `${import.meta.env.VITE_GARCON_API}/rewards/${accountId}`,
    )
    const eligibleRewards = response.data.filter((reward) => {
      return reward.refundable_in_dollars && today > reward.vest_dt
    })
    callback(eligibleRewards)
  } catch (error) {
    console.error("Request error:", error)
  }
}

export const resendRewardLegacy = async (params, callback, handleAlert) => {
  try {
    await garconClient.post(
      `${import.meta.env.VITE_GARCON_API}/rewards/${params.reward_guid}/resend`,
      params,
    )
    callback("RESENT")
    handleAlert("Reward has been successfully resent", true)
  } catch (error) {
    handleAlert(`Something went wrong: ${error}`, false)
    throw error
  }
}

export const redeemRewardLegacy = async (params, callback, handleAlert) => {
  try {
    await garconClient.post(
      `${import.meta.env.VITE_GARCON_API}/rewards/${params.reward_guid}/redeem`,
      params,
    )
    callback("REDEEMED")
    handleAlert("Reward has been successfully redeemed", true)
  } catch (error) {
    handleAlert(`Something went wrong: ${error}`, false)
    throw error
  }
}
